<template>
  <div class="template">
    <TranscriptionsViewWrapper>
      <TranscriptionsParams />
      <LoaderFullPage v-if="transcriptionListLoading" />
      <TranscriptionsData v-else />
    </TranscriptionsViewWrapper>
  </div>
</template>
<script setup lang="ts">
import LoaderFullPage from "@/follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import TranscriptionsData from "@/follaw-fr/components/transcriptions/organisms/TranscriptionsData.vue";
import TranscriptionsParams from "@/follaw-fr/components/transcriptions/organisms/TranscriptionsParams.vue";
import TranscriptionsViewWrapper from "@/follaw-fr/components/transcriptions/templates/TranscriptionsViewWrapper.vue";
import {
  useAutoFetchTranscriptionList,
  useTranscriptionsStore,
} from "@/follaw-fr/stores/transcriptions";
import { storeToRefs } from "pinia";

const { transcriptionListLoading } = storeToRefs(useTranscriptionsStore());

useAutoFetchTranscriptionList();
</script>
